module.exports = new __parcel__URL__("rayman-2-the-great-escape.70ca5cd7.jpg").toString();